<div>
  <div *ngFor="let billing of value; index as i" class="mb-27">
    <wl-pledge-edit-billing [(ngModel)]="value[i]"></wl-pledge-edit-billing>
    <div class="w-100 t-ar">
      <button
        class="atlas-btn btn-danger"
        type="button"
        [disabled]="value[i].IsARB"
        (click)="deleteBilling(i)"
        title="{{ 'common.delete' | translate | titlecase }}"
      >
        <i class="large-icon pi pi-times"></i>
        {{ 'revenue.pledge.edit.billing.remove-billing' | translate | uppercase }}
      </button>
    </div>
    <hr />
  </div>
  <div class="mct-grid mct-cols-1-1" >
    <div hidden="true">
      <p-checkbox [(ngModel)]="showInactive" [binary]="true" (ngModelChange)="loadBillings()"></p-checkbox>
      <label>{{ 'revenue.pledge.edit.billing.show-inactive-billings' | translate | ucfirst }}</label>
    </div>
    <div class="mct-flex mct-row" >
      <button pButton type="button" class="atlas-btn atlas-btn-secondary" type="button" (click)="addBilling()" title="{{ 'common.add' | translate | titlecase }}">
        <i class="large-icon pi pi-plus"></i>
        {{ 'revenue.pledge.edit.billing.add-billing' | translate | uppercase }}
      </button>
    </div>
    <wl-busy *ngIf="loading" [show]="true"></wl-busy>
  </div>
</div>
